import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";

export default function ContactForm() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/inquiries", form);
      toast.success(t("contact.success"));
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) { toast.error(formatApiError(err)); } finally { setLoading(false); }
  };

  const inputCls = "mt-2 bg-transparent border-white/20 rounded-sm h-11 focus:border-[#e65f2b]";

  return (
    <section id="contact" className="max-w-4xl mx-auto px-6 py-24" data-testid="contact-section">
      <div className="text-xs uppercase tracking-[0.3em] text-[#e65f2b]">{t("contact.title")}</div>
      <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold uppercase tracking-tight">{t("contact.reachOut")}</h2>

      <form onSubmit={submit} className="mt-10 grid md:grid-cols-2 gap-5">
        <div>
          <Label className="uppercase text-xs tracking-widest text-white/70">{t("contact.name")}</Label>
          <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className={inputCls} />
        </div>
        <div>
          <Label className="uppercase text-xs tracking-widest text-white/70">{t("contact.email")}</Label>
          <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className={inputCls} />
        </div>
        <div className="md:col-span-2">
          <Label className="uppercase text-xs tracking-widest text-white/70">{t("contact.subject")}</Label>
          <Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className={inputCls} />
        </div>
        <div className="md:col-span-2">
          <Label className="uppercase text-xs tracking-widest text-white/70">{t("contact.message")}</Label>
          <Textarea required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className={`${inputCls} min-h-32`} />
        </div>
        <div className="md:col-span-2">
          <Button type="submit" disabled={loading} data-testid="contact-submit" className="bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold uppercase tracking-widest rounded-sm h-11 px-8">
            <Send size={14} className="mr-2" />{loading ? "…" : t("contact.send")}
          </Button>
        </div>
      </form>
    </section>
  );
}
